/* ============================================================
   ps-page-specs.js — P.S. beauty by peakspan
   Reveals for the SPECIFICATIONS page only.

   ps-motion.js already owns .badgebar .badge and ps-chapters.js owns
   .psc-spectables .psc-tablewrap (and every .wow-count count-up).
   This file only picks up the blocks that are new on this page and
   gives them the same alternating left/right entrance.

   Additive, reduced-motion safe, with a 4 s safety net so nothing can
   be left invisible if the observer never fires.
   ============================================================ */
(function () {
  'use strict';

  var page = document.querySelector('.pspec');
  if (!page) { return; }

  var reduced = false;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { reduced = false; }

  if (reduced || !('IntersectionObserver' in window)) { return; }

  var selectors = [
    '.pspec-split',
    '.pspec-safety',
    '.pspec-box > li',
    '.pspec-care > .pspec-card',
    '.pspec-fit > .pspec-card',
    '.pspec-cta'
  ];

  var els = [];
  selectors.forEach(function (sel) {
    Array.prototype.forEach.call(page.querySelectorAll(sel), function (el, i) {
      if (el.classList.contains('psm-left') || el.classList.contains('psm-right')) { return; }
      el.classList.add(i % 2 === 0 ? 'psm-left' : 'psm-right');
      els.push(el);
    });
  });

  if (!els.length) { return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) { return; }
      var el = entry.target;
      var siblings = Array.prototype.filter.call(
        el.parentElement ? el.parentElement.children : [],
        function (c) {
          return c.classList.contains('psm-left') || c.classList.contains('psm-right');
        }
      );
      var idx = siblings.indexOf(el);
      window.setTimeout(function () { el.classList.add('psm-in'); }, Math.max(0, idx) * 90);
      io.unobserve(el);
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });

  els.forEach(function (el) { io.observe(el); });

  /* safety net — never leave content at opacity 0 */
  window.setTimeout(function () {
    els.forEach(function (el) { el.classList.add('psm-in'); });
  }, 4000);
})();
